import { Component, OnInit,OnDestroy } from '@angular/core';

import {TelecareServiceService} from '../services/telecare-service/telecare-service.service'
import {ForuscareService} from '../services/foruscare/foruscare.service';
import {AccountService} from '../services/account/account.service';

import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { TelecareAppointments } from '../models/telecareAppointments';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { forEach } from 'lodash';
import { element } from 'protractor';

declare var $: any;
declare  var jQuery:  any;
var disableDates = ["9-7-2020", "14-11-2019", "15-11-2019","27-12-2019"];
$('.datepicker').datepicker({
  format: 'dd-mm-yyyy',
  beforeShowDay: function(date){
    console.log(date);
      var dmy = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      if(disableDates.indexOf(dmy) != -1){
          return false;
      }
      else{
          return true;
      }
      
  }
});

@Component({
  selector: 'app-telecare-dashboard',
  templateUrl: './telecare-dashboard.component.html',
  styleUrls: ['./telecare-dashboard.component.css']
})
export class TelecareDashboardComponent implements OnInit ,OnDestroy{

  range: Range = { fromDate: new Date(), toDate: new Date() };
  options: NgxDrpOptions;
  presets: Array<PresetItem> = [];
  appointmentDashboardData:any={};
  selectedTab='patientDashboardTop';
  appointmentDetails:TelecareAppointments[]=[];
  filteredAppointmentDetails:any=[];filteredAppointmentDetailsBkUp:any=[];
  totalRegisteredPatientsCount:any=0;
  telecaredoctors:any[]=[];
  showAllDoctors:any[]=[];
  showAllDoctorsBkup:any[]=[];
  searchDoctorByEmail="";
  searchDoctorByMobile="";
  doctorId=0;
  doctorId_invoice=0;
  loadingDoctors:Boolean=false;
  doctorVerificationPending:any[]=[];
  selectedPaymentFilter='ALL';
  selectedAppointmentFilter="ALL";
  invoice:any={};
  percentageDeduction:number=0;
  selectedDate:any=null;
  invoices:any[]=[];
  invoiceStartDate=this.getFormattedDate2(new Date());
  invoiceEndDate= this.getFormattedDate2(new Date());;
  uploadedDoctorDocList=[];
  loadingUploadedDoctorDocList=false;
  doctorBankDetails=null;
  loadingDoctorBankDetails=true;
  pendingAppointmentDate=null;
  getValueByKey={
    "PAYMENT_SUCCESS":"Success","PAYMENT_INITIATED":"Initiated","PAYMENT_FAILED":"Failed","PAYMENT_CANCELLED":"Payment Cancelled",
    "REFUND_INITIATED":"Refund Initiated","REFUND_COMPLETED":"Full Refunded","REFUND_FAILED":"Failed",
    "SCHEDULED":"Booked","RESCHEDULED":"Rescheduled","COMPLETED":"Completed","CANCELLED":"Cancelled","INPROGRESS":"In Progress","REJECTED":"Rejected","REOPENED":"Re-opened","ELAPSED":"Elapsed","ROLE_TELE_PATIENT":"Patient","ROLE_TELE_EXPERT":"Doctor","CALLINPROGRESS":"Call In Progress",
    "NA":"Not Available"
  };

  constructor(private telecareService:TelecareServiceService,private foruscareService:ForuscareService,private accountService:AccountService,private serviceProviderService:ServiceProviderService) { 

  }

  ngOnInit() {
    //$("#content-wrapper").removeClass("content-wrapper"); // set top bar
    $('.content-wrapper').css('padding-top','0px'); // set top bar
    //this.getAllDoctors(); // load all teh doctors in dropdown
    this.toggleTopBar('doctorDashboardTop') // default top bar
    this.getAllDoctors(); // refreshing doctor list
    this.activateDoctorVerificationPage();
    this.getAppointmentDashboardData(); //default statistics for current date
    const today = new Date();
    const fromMin = new Date(today.getFullYear(), today.getMonth() - 2, 1);
    const fromMax = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const toMin = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const toMax = new Date(today.getFullYear(), today.getMonth() + 2, 0);

    this.setupPresets();
    this.options = {
      presets: this.presets,
      format: 'mediumDate',
      range: { fromDate: today, toDate: today },
      applyLabel: "Submit",
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
        hasBackdrop: false
      }
    };
  }
  ngOnDestroy(){
    //$("#content-wrapper").addClass("content-wrapper");
    $('.content-wrapper').css('padding-top','0px');
  }
  setupPresets() {
    const backDate = (numOfDays) => {
      const today = new Date();
      return new Date(today.setDate(today.getDate() - numOfDays));
    }

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7)
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: "Yesterday", range: { fromDate: yesterday, toDate: yesterday } },
      { presetLabel: "Last 7 Days", range: { fromDate: minus7, toDate: today } },
      { presetLabel: "Last 30 Days", range: { fromDate: minus30, toDate: today } },
      { presetLabel: "This Month", range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: "Last Month", range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ]
  }

  toggleTopBar(id){
    
    this.selectedTab=id;
    switch(id){
      case 'patientDashboardTop':
        $('#patientDashboardTop').css('background','#598496');
        $('#doctorDashboardTop').css('background','#D3D3D3');
        $('#paymentDashboardTop').css('background','#D3D3D3');
        $('#allDoctorsTop').css('background','#D3D3D3');
        this.activateAppointmentDashboardPage();
        break;
      case 'doctorDashboardTop':
        $('#patientDashboardTop').css('background','#D3D3D3');
        $('#doctorDashboardTop').css('background','#598496');//css('background','#46be8a');
        $('#paymentDashboardTop').css('background','#D3D3D3');
        $('#allDoctorsTop').css('background','#D3D3D3');
        //this.activateDoctorVerificationPage();
        //this.getAllDoctors(); // refreshing doctor list
        break;
      case 'paymentDashboardTop':
        $('#patientDashboardTop').css('background','#D3D3D3');
        $('#doctorDashboardTop').css('background','#D3D3D3');
        $('#paymentDashboardTop').css('background','#598496');//css('background','#fdb45d');
        $('#allDoctorsTop').css('background','#D3D3D3');
        this.activateInvoicePage();
        break;
      case 'allDoctorsTop':
        $('#patientDashboardTop').css('background','#D3D3D3');
        $('#doctorDashboardTop').css('background','#D3D3D3');
        $('#paymentDashboardTop').css('background','#D3D3D3');
        $('#allDoctorsTop').css('background','#598496');//css('background','#fdb45d');
        this.activateShowAllDoctorsPage();
        break;
      default:
        $('#patientDashboardTop').css('background','#598496');//css('background','#59c2e6');
        $('#doctorDashboardTop').css('background','#D3D3D3');
        $('#paymentDashboardTop').css('background','#D3D3D3');
        $('#allDoctorsTop').css('background','#D3D3D3');

    }
  }

    // handler function that receives the updated date range object
    updateRange(range: Range) {
      this.range = range;
      if(this.range.fromDate>this.range.toDate){
        this.foruscareService.showNotification("Start Date can not be greater than the End Date","danger");
        return;
      }
    }
    getFormattedDate(dateString){
      var date= new Date(dateString);
      //var formattedDate = (date.getDate()<10?'0'+date.getDate():date.getDate())+"-"+((date.getMonth()+1)<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+"-"+date.getFullYear();
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric'
      }).replace(/ /g, '-');
      return formattedDate;
    }
    getFormattedDate2(dateString){
      var date= new Date(dateString);
      var formattedDate = date.getFullYear()+"-"+((date.getMonth()+1)<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+"-"+(date.getDate()<10?'0'+date.getDate():date.getDate());
      return formattedDate;
    }
    getFormattedDateTime(dateString){
      var date= new Date(dateString);
      var formattedDateTime = date.toLocaleDateString('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric'
      }).replace(/ /g, '-');
      formattedDateTime = formattedDateTime+" "+date.toLocaleTimeString('en-GB'); // 24 hr format
      //formattedDateTime = formattedDateTime+" "+date.toLocaleTimeString('en-US'); // 12 hr format
      return formattedDateTime;
    }
    getFormattedTime(dateString){
      var date= new Date(dateString);
      var formattedDateTime =date.toLocaleTimeString('en-GB').substring(0,5); // 24 hr format
      //formattedDateTime = formattedDateTime+" "+date.toLocaleTimeString('en-US'); // 12 hr format
      return formattedDateTime;
    }

    getAllDoctors() {
      this.loadingDoctors=true;
      this.telecaredoctors = [];
      this.doctorVerificationPending = [];
      this.telecareService.getAllDoctors()
        .subscribe(response => {
          if (response!=null) {
                /*response.forEach(element => {
                  if(element.firstName!=null && element.lastName!=null)
                  this.telecaredoctors.push({doctorname : element.firstName+" "+element.lastName,id : Number(element.userId)});
                });*/
                response = response.sort((a,b)=>Date.parse(b.created) - Date.parse(a.created));
                this.showAllDoctors=JSON.parse(JSON.stringify(response.filter(function(t){return t.isRegistered==true;}))); // for show all doctors page
                this.showAllDoctorsBkup=JSON.parse(JSON.stringify(response.filter(function(t){return t.isRegistered==true;}))); // for show all doctors page
                response.forEach(element => {
                  if(element.isVerified!="NOT_VERIFIED"){
                      if(element.isActive==true){
                        if((element.firstName==null || element.firstName=="null") || (element.lastName==null || element.firstName=="null")){
                        }
                        else{
                          element.firstName=(element.firstName!=null?(element.firstName[0].toUpperCase()+element.firstName.substring(1).toLowerCase()):"")
                          +" "+(element.lastName[0]!=null?(element.lastName[0].toUpperCase()+element.lastName.substring(1).toLowerCase()):"");
                        }
                        this.telecaredoctors.push(element);
                    }
                  }
                  else{
                    if(element.isRegistered){
                    this.doctorVerificationPending.push(element);
                    }
                  }
                })
                //this.telecaredoctors=response; 
                this.telecaredoctors = this.telecaredoctors.sort(this.sortAscendingOrder("firstName"));
                this.telecaredoctors.unshift({
                  firstName: 'All',
                  userId: 0
                });
                
                this.loadingDoctors=false;
                this.getUnVarifiedDoctors(); // doctors verification pending
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        });
    }
    sortAscendingOrder(prop) {    
      return function(a, b) {    
          if (a[prop] > b[prop]) {    
              return 1;    
          } else if (a[prop] < b[prop]) {    
              return -1;    
          }    
          return 0;    
      }    
    } 
    downloadBase64FileByUrlAndName(reporturl,fileName):void{
      this.serviceProviderService.getBlobURLtobase64(reporturl)
      .subscribe(response => {
          if(response.errorCode==200){
              var link = document.createElement("a");
              link.style.display = "none";
              link.download = fileName;
              link.href = 'data:application/octet-stream;base64,' + response.data;
              document.body.appendChild(link);
              link.click();
              //window.URL.revokeObjectURL(url);
          }
          else{
              this.foruscareService.showNotification("File download failed","danger");
          }
      });
    }
    /* start : appointment dashboard*/
    activateAppointmentDashboardPage(){
      this.telecaredoctors.forEach(function(element,index) {
        if(element.userId==0 || element.userId=="0"){
          element.firstName = "All";
        }
      });
    }
    exportAppointmentDetails(){
      $("#iframe").attr("src",this.foruscareService.baseTelecareURL() + "/dashboard/exportAppointmentDetails/"+this.selectedDate+"/"+this.doctorId+"/"+this.selectedAppointmentFilter+"/"+this.selectedPaymentFilter);
    }
    exportAppointmentDateWiseSplit(){
      $("#iframe").attr("src",this.foruscareService.baseTelecareURL() + "/dashboard/exportDatewiseCount/"+this.foruscareService.getDateForServerAPI(this.range.fromDate)+"/"+this.foruscareService.getDateForServerAPI(this.range.toDate)+"/"+this.doctorId);
    }
    getAppointmentDashboardData() {
      if(this.range.fromDate>this.range.toDate){
        this.foruscareService.showNotification("Start Date can not be greater than the End Date","danger");
        return;
      }
      if (this.range.fromDate != null && this.range.toDate != null) {
        this.appointmentDashboardData = {};
        /*get registered patient count */
        this.telecareService.getRegisteredPatientsByDateRange(this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate))
          .subscribe(response => {
            if (response!=null) {
              this.totalRegisteredPatientsCount=response;
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          });
        /*get appointment statistics */
        this.doctorId=(this.doctorId==null?0:this.doctorId);
        this.telecareService.getAppointmentDashboardDataByDateRange(this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate),this.doctorId)
          .subscribe(response => {
            if (response!=null) {
                  this.appointmentDashboardData = response;
                  //this.appointmentDashboardData.appointmentDatewiseList = this.appointmentDashboardData.appointmentDatewiseList.reverse();
                  this.appointmentDashboardData.appointmentDatewiseList = this.appointmentDashboardData.appointmentDatewiseList.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          });
      }
      else {
        this.foruscareService.showNotification("Please select valid date range", "danger");
      }
    }

    filterTransactions = function (status) {
      this.selectedAppointmentFilter = status;
      this.filterTransactionsByPaymentStatus();
      //to remove underline of of unselected items in ul-li
      $('#all').css("border-bottom", "none"); 
      $('#booked').css("border-bottom", "none");
      $('#rescheduled').css("border-bottom", "none"); 
      $('#completed').css("border-bottom", "none"); 
      $('#cancelled').css("border-bottom", "none");

     
      /* appointment status filter */
      if (status == "ALL") {
        $('#all').css("border-bottom", "2px solid rgb(53,191,224");
       // this.filteredAppointmentDetails = this.appointmentDetails;
        //this.filteredAppointmentDetailsBkUp = this.appointmentDetails;
      }
      else if (status == "SCHEDULED") {
        $('#booked').css("border-bottom", "2px solid rgb(53,191,224");
        /*this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus == "SCHEDULED";
        });*/
      }
      else if (status == "RESCHEDULED") {
       /* $('#rescheduled').css("border-bottom", "2px solid rgb(53,191,224");
        this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus == "RESCHEDULED";
        });*/
      }
      else if (status == "COMPLETED") {
        $('#completed').css("border-bottom", "2px solid rgb(53,191,224");
        /*this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus == "COMPLETED";
        });*/
      }
      else if (status == "CANCELLED") {
        $('#cancelled').css("border-bottom", "2px solid rgb(53,191,224");
        /*this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus =='CANCELLED';
        });*/
      }
    }
    filterTransactionsByPaymentStatus(){
      var tempselectedPaymentFilter = this.selectedPaymentFilter;
      var tempselectedAppointmentFilter = this.selectedAppointmentFilter;
      if(this.selectedAppointmentFilter=="ALL" &&  this.selectedPaymentFilter == "ALL")
      {
        this.filteredAppointmentDetails = this.appointmentDetails;
      }
      else if(this.selectedAppointmentFilter=="ALL" &&  this.selectedPaymentFilter != "ALL")
      {
        this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.paymentStatus == tempselectedPaymentFilter;
        });
      }
      else if(this.selectedAppointmentFilter!="ALL" &&  this.selectedPaymentFilter == "ALL")
      {
        if(this.selectedAppointmentFilter == 'RESCHEDULED'){
          this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
            return t.isRescheduled == true;
          });
        }
        else{
          this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus == tempselectedAppointmentFilter;
        });
        }
      }
      else if(this.selectedAppointmentFilter!="ALL" &&  this.selectedPaymentFilter != "ALL")
      {
        if(this.selectedAppointmentFilter == 'RESCHEDULED'){
          this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
            return t.isRescheduled == true && t.paymentStatus == tempselectedPaymentFilter ;
          });
        }
        else{
          this.filteredAppointmentDetails = this.appointmentDetails.filter(function (t) {
          return t.appointmentStatus == tempselectedAppointmentFilter && t.paymentStatus == tempselectedPaymentFilter ;
        });
        }
      }
       /* payment status filter */

     /*  if (paymentStatus == "ALL") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp;
      }
      else if (paymentStatus == "PAYMENT_INITIATED") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == "PAYMENT_INITIATED";
        });
      }
      else if (paymentStatus == "PAYMENT_SUCCESS") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == "PAYMENT_SUCCESS";
        });
      }
      else if (paymentStatus == "PAYMENT_FAILED") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == "PAYMENT_FAILED";
        });
      }
      else if (paymentStatus == "REFUND_INITIATED") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == this.getValueByKey["REFUND_INITIATED"];
        });
      }
      else if (paymentStatus == "REFUND_COMPLETED") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == this.getValueByKey["REFUND_COMPLETED"];
        });
      }
      else if (paymentStatus == "REFUND_FAILED") {
        this.filteredAppointmentDetails = this.filteredAppointmentDetailsBkUp.filter(function (t) {
          return t.paymentStatus == this.getValueByKey["REFUND_FAILED"];
        });
      }*/
    }
    showAppointDetailsByDate(date){
      //$('#appointMentDetailsPopUp').modal('show');
      this.selectedDate = date;
      this.telecareService.getAppointmentDashboardDetails(date,this.doctorId)
          .subscribe(response => {
            if (response!=null) {
                  this.appointmentDetails = response;
                  this.filterTransactions('ALL');
                  //mapping doctor details
                  this.appointmentDetails.forEach(appointmentElement => {
                    var matchedDoctor = this.showAllDoctors.filter(ob => ob.userId == appointmentElement.doctorId);
                      if(matchedDoctor!=null && matchedDoctor[0]!=null && matchedDoctor.length>0){
                      appointmentElement.doctorName = ((matchedDoctor[0].title!=null?matchedDoctor[0].title.toUpperCase().substring(0,1)+matchedDoctor[0].title.substring(1).toLowerCase():"")
                                                      +" "+(matchedDoctor[0].firstName)+" "+(matchedDoctor[0].lastName));
                      appointmentElement.doctorSpecialization = matchedDoctor[0].degree;
                      }
                  });
                  //fetching doctor details
                 /* var doctorIds=[];
                  this.appointmentDetails.forEach(element => {
                    doctorIds.push(element.doctorId);
                  });
                    this.telecareService.getDoctorDetailsById(doctorIds)
                    .subscribe(doctorResponse => {
                      if (doctorResponse!=null) {
                            doctorResponse.forEach(doctorResponseElement => {
                              this.appointmentDetails.forEach(appointmentElement => {
                                if(appointmentElement.doctorId==doctorResponseElement.userId){
                                  appointmentElement.doctorName = doctorResponseElement.title[0].toUpperCase()+doctorResponseElement.title.substring(1).toLowerCase()
                                                                  +" "+doctorResponseElement.firstName[0].toUpperCase()+doctorResponseElement.firstName.substring(1).toLowerCase()
                                                                  +" "+doctorResponseElement.lastName[0].toUpperCase()+doctorResponseElement.lastName.substring(1).toLowerCase();
                                  appointmentElement.doctorSpecialization = doctorResponseElement.degree;
                                }
                              });
                            });
                          } 
                      else {
                        this.foruscareService.showNotification(response.message, "danger");
                      }
                      console.log(this.appointmentDetails);
                  });*/
                  //this.appointmentDashboardData.appointmentDatewiseList = this.appointmentDashboardData.appointmentDatewiseList.reverse();
                  //this.appointmentDashboardData.appointmentDatewiseList = this.appointmentDashboardData.appointmentDatewiseList.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          });
    }
    /* end : appointment dashboard*/
    /* start : verifying doctor page codes */
    activateDoctorVerificationPage(){
      this.doctorVerificationPending = this.doctorVerificationPending.sort((a,b)=>Date.parse(b.created) - Date.parse(a.created));
      if(this.doctorVerificationPending!=null && this.doctorVerificationPending.length>0){
        this.getUploadedDocuments(this.doctorVerificationPending[0].userId);
        this.getBankDetailsByDoctorId(this.doctorVerificationPending[0].userId);
      }
    }
    getUploadedDocuments(userId){
    this.uploadedDoctorDocList=[];
    this.loadingUploadedDoctorDocList=true;
      this.telecareService.getUploadedDocuments(userId)
      .subscribe(response=>{
        this.uploadedDoctorDocList = response;
        this.loadingUploadedDoctorDocList=false;
      });
    }
    getBankDetailsByDoctorId(userId){
      this.doctorBankDetails=null;
      this.loadingDoctorBankDetails=true;
        this.telecareService.getBankDetailsByDoctorId(userId)
        .subscribe(response=>{
          this.doctorBankDetails = response;
          this.loadingDoctorBankDetails=false;
        });
      }
    getUnVarifiedDoctors(){
      /*var temp = this.telecaredoctors.filter(function(t){
        return t.isVerified == false;
      });*/
      if(this.doctorVerificationPending!=null && this.doctorVerificationPending.length>0){
        this.getUploadedDocuments(this.doctorVerificationPending[0].userId);
        this.getBankDetailsByDoctorId(this.doctorVerificationPending[0].userId);
      }
    }
    reviewLater(){
      if(this.doctorVerificationPending!=null && this.doctorVerificationPending.length>0){
      var obj = this.doctorVerificationPending[0];
      this.doctorVerificationPending.splice(0,1);
      this.doctorVerificationPending.push(obj);
      this.percentageDeduction = 0; // making default 0
      this.getUploadedDocuments(this.doctorVerificationPending[0].userId);
      this.getBankDetailsByDoctorId(this.doctorVerificationPending[0].userId);
      }
    }
    updateDoctorStatusById(userId:String,isActiveStatus:Boolean,isVerifiedStatus:String,serviceCharge:String,forceUpdate:Boolean){
      if(forceUpdate==true){
        /*if(isVerifiedStatus==true){
          this.toggleTopBar('doctorDashboardTop') // switching to doctor verification tab
          //adding selected doctor as first element in the queue 
          var tempObj;
          var foundIndex;
          this.doctorVerificationPending.forEach(function(element,index) {
            if(element.userId==userId){
              tempObj=element;
              foundIndex=index;
            }
          });
          this.doctorVerificationPending.splice(foundIndex,1);
          this.doctorVerificationPending.splice(0,0,tempObj);
          this.getUploadedDocuments(this.doctorVerificationPending[0].userId);
          this.getBankDetailsByDoctorId(this.doctorVerificationPending[0].userId);
          this.foruscareService.showNotification("Doctor has to be verified before enabling","warning");
          return false;
        }*/
        //else{
        if(serviceCharge==null && isActiveStatus==false){
          this.telecareService.getlastDateOfDoctorAppointment(userId)
          .subscribe(response => {
            if(response!=null && response.date!=null && this.getFormattedDate2(new Date(response.date))>= this.getFormattedDate2(new Date())){
            this.pendingAppointmentDate = this.getFormattedDate(new Date(response.date));
            this.showAllDoctors.forEach(element => {
              if(element.userId==userId){
                element.isActive = true;
              }
            });
            $('#deactivateDoctorPopUp').modal('show');
            //this.updateDoctorStatusServiceChargeById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate);
            return false;
            }
            else{
              this.updateDoctorStatusServiceChargeById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate);
            }
          });
        }
        else{
          if(this.verifyPercentageDeduction(serviceCharge)==true){
            this.updateDoctorStatusServiceChargeById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate);
          }
        }
        //}
      }
      else if(this.verifyPercentageDeduction(serviceCharge)==true){
        this.updateDoctorStatusServiceChargeById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate);
      }
      else{
        this.foruscareService.showNotification("Please enter valid amount","danger");
          return false;
      }
    }
    hideDeactivateDoctorPopUp(){
      $('#deactivateDoctorPopUp').modal('hide');
    }
    updateDoctorStatusServiceChargeById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate){
      this.telecareService.updateDoctorStatusById(userId,isActiveStatus,isVerifiedStatus,serviceCharge,forceUpdate)
        .subscribe(response => {
          if (response!=null) {
            for (let index = 0; index < this.doctorVerificationPending.length; index++) {
              if(this.doctorVerificationPending[index].userId==userId){
                this.doctorVerificationPending.splice(index,1);
                break;
              }
            }
            if(response>=0){
              this.percentageDeduction = 0; // making default 0
              this.getAllDoctors(); // refreshing doctor list
              if(this.doctorVerificationPending!=null && this.doctorVerificationPending.length>0){
              this.getUploadedDocuments(this.doctorVerificationPending[0].userId);
              this.getBankDetailsByDoctorId(this.doctorVerificationPending[0].userId);
              }
              this.foruscareService.showNotification("Doctor status update successfully","success");
            }
            else{
              this.foruscareService.showNotification("Already verified by other admin","warning");
            }
          }
          else{
            this.foruscareService.showNotification("Something went wrong","danger");
          }
        });
    }
    viewDocument(url,type){
      this.serviceProviderService.getBlobURLtobase64(url)
        .subscribe(response=>{
          if(response.errorCode==200){
            var obj = document.createElement('object');
                            obj.style.width = '100%';
                            obj.style.height = '100%';
                            if(type.toUpperCase()=='PDF'){
                            obj.type = 'application/pdf';
                            obj.data = 'data:application/pdf;base64,' + response.data;
                            }
                            else if(type.toUpperCase()=='JPG' || type.toUpperCase()=='JPEG' || type.toUpperCase()=='PNG'){
                            obj.type = 'image/jpeg';
                            obj.data = 'data:image/jpeg;base64,' + response.data;
                            }
                            document.getElementById('doctorDocumentPreviewBody').innerHTML=obj.outerHTML;
                            $('#doctorDocumentPreviewPopUp').modal('show');
          }
          else{
            this.foruscareService.showNotification("Preview not available","danger");
        }
        });
    }
    hideDoctorDocumentPreviewPopUp(){
      $('#doctorDocumentPreviewPopUp').modal('hide');
    }
    /*end : verifying doctor code */

    /*start : show all doctors */
    activateShowAllDoctorsPage(){
      this.showAllDoctors=this.showAllDoctorsBkup;
    }
    filterDoctor(emailFilter,mobileFilter){
      if(emailFilter.trim().length==0 && mobileFilter.trim().length==0){
        this.showAllDoctors=this.showAllDoctorsBkup;
      }
      else if(emailFilter.trim().length==0 && mobileFilter.trim().length>0){
        this.showAllDoctors = this.showAllDoctorsBkup.filter(function(t){
          return (t.mobileNumber!=null && t.mobileNumber.indexOf(mobileFilter)>=0);
        });
      }
      else if(emailFilter.trim().length>0 && mobileFilter.trim().length==0){
        this.showAllDoctors = this.showAllDoctorsBkup.filter(function(t){
          return (t.email!=null && t.email.indexOf(emailFilter)>=0);
        });
      }
      else if(emailFilter.trim().length>0 && mobileFilter.trim().length>0){
      this.showAllDoctors = this.showAllDoctorsBkup.filter(function(t){
        return (t.email!=null && t.email.indexOf(emailFilter)>=0) && (t.mobileNumber!=null && t.mobileNumber.indexOf(mobileFilter)>=0);
      });
      }
    }
    showDoctorDetailsPopUp(doctor){
      this.telecareService.getBankDetailsByDoctorId(doctor.userId)
        .subscribe(response=>{
          if(response!=null){
          var temphtml = "<table style='margin-top:5%' class='table table-bordered'>"+
          "<tr><td>Name</td><td>"+(doctor.firstName)+" "+(doctor.lastName)+"</td></tr>"+
          "<tr><td>Email</td><td>"+(doctor.email==null?'NA':doctor.email)+"</td></tr>"+
          "<tr><td>Mobile</td><td>"+(doctor.mobileNumber==null?'NA':doctor.mobileNumber)+"</td></tr>"+
          "<tr><td>Bank Name</td><td>"+(response.bankName==null?'NA':response.bankName)+"</td></tr>"+
          "<tr><td>Branch Name</td><td>"+(response.branchName==null?'NA':response.branchName)+"</td></tr>"+
          "<tr><td>Account Number</td><td>"+(response.accountNumber==null?'NA':response.accountNumber)+"</td></tr>"+
          "<tr><td>IFSC Code</td><td>"+(response.ifsc==null?'NA':response.ifsc)+"</td></tr>"+
          "</table>";
          $('#doctorDetailsBody').html(temphtml);
          $('#doctorDetailsPopUp').modal("show");
          }
          else{
            var temphtml = "<table style='margin-top:5%' class='table table-bordered'>"+
            "<tr class='text-center'><td colspan='3'>Not Available</td></tr>"+
            "</table>";
            $('#doctorDetailsBody').html(temphtml);
            $('#doctorDetailsPopUp').modal("show");
          }
        });
    }
    hideDoctorDetailsPopUp(){
      $('#doctorDetailsPopUp').modal("hide");
    }
    /*end : show all doctors */
    /* start : invoice billing code*/
    activateInvoicePage(){
      this.telecaredoctors.forEach(function(element,index) {
        if(element.userId==0 || element.userId=="0"){
          element.firstName = "All";
        }
      });
    }
    verifyPercentageDeduction(serviceCharge){
      if(serviceCharge!=null){
        if(serviceCharge.toString().indexOf("e")>=0 || serviceCharge.toString().indexOf("-")>=0 || serviceCharge.toString().indexOf("+")>=0 || serviceCharge.toString().split(".").length>2){
          this.foruscareService.showNotification("Please enter valid amount","danger");
          return false;
        }
        else{
          if(serviceCharge.toString().split(".").length==2){
            if(serviceCharge.toString().split(".")[1].length>2){
              this.foruscareService.showNotification("Allowed upto 2 decimal places","danger");
              return false;
            }
          }
          return true;
        }
      }
      
        else{
          this.foruscareService.showNotification("Please enter valid amount","danger");
          return false;
        }
    }
    generateInvoice(){
      if(this.doctorId_invoice == 0){
        this.foruscareService.showNotification("Please select a doctor","danger");
        return false;
      }
      this.telecareService.generateInvoice(this.invoiceStartDate,this.invoiceEndDate,this.doctorId_invoice,this.percentageDeduction)
      .subscribe(response => {
       this.invoices = response;
      });
      /*if(this.verifyPercentageDeduction()==true){
       // $("#iframe").attr("src",this.foruscareService.baseTelecareURL()+"/dashboard/generatePDFInvoive/"+this.foruscareService.getDateForServerAPI(this.range.fromDate)+"/"+this.foruscareService.getDateForServerAPI(this.range.toDate)+"/"+this.doctorId_invoice+"/"+this.percentageDeduction);
      */
      }
      /*fetchPercentageDeduction(userId){
        this.percentageDeduction = 0;
        var doctor = this.telecaredoctors.filter(function(t){
          return t.userId == userId; 
        });
        this.percentageDeduction = doctor[0].opd.forusShare==null?0:doctor[0].opd.forusShare;
      }*/
      /*this.telecareService.generateInvoice(this.foruscareService.getDateForServerAPI(this.range.fromDate),this.foruscareService.getDateForServerAPI(this.range.toDate),this.doctorId_invoice,this.percentageDeduction)
      .subscribe(response => {
          if (response!=null) {
          this.invoice=response;
          this.invoice.doctorFee=Number(this.invoice.doctorFee);
          this.invoice.totalCompletedConsultations=Number(this.invoice.totalCompletedConsultations);
          this.invoice.totalCancelledConsultationsByPatient=Number(this.invoice.totalCancelledConsultationsByPatient);
          this.invoice.totalCompletedConsultationsByDoctor=Number(this.invoice.totalCompletedConsultationsByDoctor);
          console.log(this.invoice);
          $('#invoicePreviewPopUp').modal('show');
          }
          else{
            this.foruscareService.showNotification("Something went wrong","danger");
          }
        });*/
    
    fetchInvoices(){
      this.telecareService.getInvoicesByDoctor(this.doctorId_invoice)
      .subscribe(response => {
        if (response!=null) {
          this.invoices = response;
          //var minDate = this.invoices.sort((a, b) => Date.parse(a.startDate) - Date.parse(b.startDate))[0].startDate;
          var maxDate = this.invoices.sort((a, b) => Date.parse(b.endDate) - Date.parse(a.endDate))[0].endDate; //descending order
          maxDate = new Date(maxDate);
          maxDate = maxDate.setDate(maxDate.getDate()+1);
          maxDate = new Date(maxDate);
          $("#invoiceStartDate").attr("min",this.getFormattedDate2(maxDate));
          $("#invoiceStartDate").attr("max",this.getFormattedDate2(maxDate));
          //$("#invoiceStartDate").attr("max",maxDate);
          $("#invoiceEndDate").attr("min",this.getFormattedDate2(maxDate));
          //$("#invoiceEndDate").attr("max",maxDate);
          this.invoiceStartDate=this.getFormattedDate2(maxDate);
          this.invoiceEndDate=this.getFormattedDate2(maxDate);
        }
      });
    }
    exportInvoiceExcel(invoiceStartDate,invoiceEndDate,doctorId){
      $("#iframe").attr("src",this.foruscareService.baseTelecareURL() + "/dashboard/exportInvoiceExcel/"+invoiceStartDate+"/"+invoiceEndDate+"/"+doctorId);
    }
    
    /*end : invoice billing code*/
}
